import React from "react";
import { useReveal } from "@/hooks/useReveal";
import { ArrowUpRight } from "lucide-react";

const CLASSES = [
  {
    id: "matwork",
    number: "i",
    name: "Pilates Matwork",
    duration: "50 min · 7 alunos",
    image: "/media/luft-matwork-practice.jpg",
    description:
      "A prática original sobre o tapete. Trabalho de centro, alinhamento e respiração para um corpo mais consciente.",
  },
  {
    id: "reformer",
    number: "ii",
    name: "Reformer",
    duration: "50 min · 4 alunos",
    image: "/media/luft-pulleys.jpg",
    description:
      "Pilates em equipamento Merrithew. Resistência variável, fluidez e precisão para fortalecer e alongar em simultâneo.",
  },
  {
    id: "yoga",
    number: "iii",
    name: "Yoga",
    duration: "60 min",
    image: "/media/luft-yoga-practice.jpg",
    description:
      "Uma prática suave e atenta, com foco na respiração e na presença. Para acalmar a mente e abrir o corpo.",
  },
  {
    id: "privadas",
    number: "iv",
    name: "Sessões Privadas",
    duration: "50 — 80 min",
    image: "/media/luft-private-session.jpg",
    description:
      "Atenção exclusiva, programa desenhado para si. Ideal para iniciar, recuperar ou aprofundar a prática.",
  },
];

export default function Classes() {
  const ref = useReveal();

  return (
    <section
      id="aulas"
      ref={ref}
      className="relative bg-[var(--luft-bg-alt)] py-32 sm:py-44 lg:py-52"
      data-testid="classes-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-24 reveal">
          <div>
            <p className="eyebrow mb-8">02 — Aulas</p>
            <h2 className="editorial-heading text-[clamp(2.2rem,5.4vw,4.4rem)] text-[var(--luft-ink)] max-w-3xl">
              Quatro formas de <em className="editorial-italic">habitar</em><br />
              o próprio corpo.
            </h2>
          </div>
          <p className="font-body font-light text-[var(--luft-ink-soft)] max-w-sm leading-relaxed">
            Cada modalidade é pensada para grupos pequenos, ritmo próprio e uma escuta atenta a cada corpo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 lg:gap-x-14 gap-y-20 lg:gap-y-24">
          {CLASSES.map((c) => (
            <article
              key={c.id}
              className="reveal group"
              data-testid={`class-card-${c.id}`}
            >
              <div
                className="relative overflow-hidden bg-[var(--luft-bg)]"
                style={{ borderRadius: "var(--radius-organic)" }}
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
                  />
                </div>
                <span
                  className="absolute top-6 left-6 font-display italic text-white text-2xl drop-shadow-[0_1px_8px_rgba(0,0,0,0.25)]"
                  aria-hidden="true"
                >
                  {c.number}
                </span>
              </div>

              <div className="mt-10 flex items-start justify-between gap-6">
                <div>
                  <h3 className="editorial-heading text-3xl sm:text-4xl text-[var(--luft-ink)]">
                    {c.name}
                  </h3>
                  <p className="eyebrow mt-4">{c.duration}</p>
                </div>
                <ArrowUpRight
                  size={26}
                  strokeWidth={1}
                  className="text-[var(--luft-ink)] mt-2 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>

              <p className="mt-6 text-[var(--luft-ink-soft)] font-body font-light leading-relaxed max-w-md">
                {c.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
